import { render } from "./Topnav.vue?vue&type=template&id=5173cb0b&scoped=true"
import script from "./Topnav.vue?vue&type=script&lang=js"
export * from "./Topnav.vue?vue&type=script&lang=js"

import "./Topnav.vue?vue&type=style&index=0&id=5173cb0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5173cb0b"]])

export default __exports__